import { useAuthStore } from '@/stores/authStore'
import { isReadOnlyRole } from '@/config/roles'

/**
 * The principal is read-only (Omar, 31 Oct 2026: "School admin and principal: two roles, one
 * menu, the principal is read-only."). The server refuses every write he sends (403,
 * app/core/dependencies.py); in the panel this hook drives the "View only" banner, the disabled
 * action buttons (design/Button) and the client-side stop in lib/api/client.ts.
 */
export function useReadOnly(): boolean {
  return useAuthStore((s) => isReadOnlyRole(s.user?.role))
}

export const VIEW_ONLY_MESSAGE = 'View only: a principal can see everything but cannot change anything.'

/** What a principal may still send that is not a read: his own account only (the server agrees). */
const OWN_ACCOUNT = ['/auth/logout', '/auth/change-password', '/auth/profile', '/auth/phone', '/auth/refresh']

export function isBlockedForReadOnly(method: string | undefined, url: string | undefined): boolean {
  const m = (method ?? 'get').toLowerCase()
  if (m === 'get' || m === 'head' || m === 'options') return false
  const path = (url ?? '').split('?')[0].replace(/\/+$/, '')
  return !OWN_ACCOUNT.some((p) => path.endsWith(p))
}
